export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'

export const VALIDATE_OTP_LOADING = 'VALIDATE_OTP_LOADING'
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS'
export const VALIDATE_OTP_FAILED = 'VALIDATE_OTP_FAILED'

export const VALIDATE_OTP_ARN_LOADING = 'VALIDATE_OTP_ARN_LOADING'
export const VALIDATE_OTP_ARN_SUCCESS = 'VALIDATE_OTP_ARN_SUCCESS'
export const VALIDATE_OTP_ARN_FAILED = 'VALIDATE_OTP_ARN_FAILED'